import { Box, BoxProps, Typography } from '@mui/material';

export default function InnerWithTabsTitle({ children, ...rest }: BoxProps) {
  return (
    <Box paddingLeft="30px" marginBottom="11px" {...rest}>
      <Typography variant="subtitle1">{children}</Typography>
    </Box>
  );
}
